var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.81824 10.9091C1.81824 5.8909 5.89096 1.81818 10.9091 1.81818C15.9273 1.81818 20.0001 5.8909 20.0001 10.9091C20.0001 15.9273 15.9273 20 10.9091 20C5.89096 20 1.81824 15.9273 1.81824 10.9091ZM11.8182 14.5454V16.3636H10.0001V14.5454H11.8182ZM10.9091 18.1818C6.90006 18.1818 3.63642 14.9182 3.63642 10.9091C3.63642 6.89999 6.90006 3.63636 10.9091 3.63636C14.9182 3.63636 18.1819 6.89999 18.1819 10.9091C18.1819 14.9182 14.9182 18.1818 10.9091 18.1818ZM7.27278 9.0909C7.27278 7.08181 8.90006 5.45454 10.9091 5.45454C12.9182 5.45454 14.5455 7.08181 14.5455 9.0909C14.5455 10.2572 13.8273 10.8848 13.128 11.4959C12.4646 12.0757 11.8182 12.6406 11.8182 13.6364H10.0001C10.0001 11.9807 10.8565 11.3242 11.6095 10.747C12.2003 10.2942 12.7273 9.89019 12.7273 9.0909C12.7273 8.0909 11.9091 7.27272 10.9091 7.27272C9.90915 7.27272 9.09096 8.0909 9.09096 9.0909H7.27278Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.c6914e605d0d22138a61ce3c2a1ba66c.svg";
export { ForwardRef as ReactComponent };